import React, { useMemo } from 'react';
import './index.less';
import { formatMoney } from '@cap/share/src/utils/currency';

interface PriceProps {
  price: number;
  fixedPrice: number;
  showDiscountPrice: boolean;
}

const Price: React.FC<PriceProps> = ({ price, fixedPrice, showDiscountPrice }) => {
  const currencySymbol = '¥';
  const priceFmt = useMemo(() => {
    const { num, unit } = formatMoney(price, 1e9);
    return `${num}${unit}`;
  }, [price]);

  const fixedPriceFmt = useMemo(() => {
    const { num, unit } = formatMoney(fixedPrice, 1e9);
    return `${num}${unit}`;
  }, [fixedPrice]);
  return (
    <div className="price-wrapper">
      {showDiscountPrice ? (
        <>
          <span className="price">
            <span className="symbol">{currencySymbol}</span>
            {priceFmt}
          </span>
          <span className="del">
            <span className="symbol">{currencySymbol}</span>
            {fixedPriceFmt}
          </span>
        </>
      ) : (
        <span className="price">
          <span className="symbol">{currencySymbol}</span>
          {fixedPriceFmt}
        </span>
      )}
    </div>
  );
};

export default Price;
